import React, { useState, useImperativeHandle, forwardRef } from 'react';
import { Form, Input, InputNumber, Popconfirm, Icon, Upload, message, Button } from 'antd'
import DetailTitle from '../../../../components/DetailTitle/index';
import ModalDom from '../../../../components/Modal'
import { CustomRow, CustomCol } from '../../../../components/Custom'
import {Img} from 'react-image'
import { decorateTypeMap } from '../../../../axios/dictionaries'

const Detail = (props, ref) => {
  const [visible, setVisible] = useState(false)
  const [modalData, setModalData] = useState({})

  useImperativeHandle(ref, () => ({ // 里面的方法, 父组件可以通过 ref 获取
    onShow(data) {
      setVisible(true)
      setModalData(data)
    }
  }))

  const _fomartDecorate = (type) => {
    const current = decorateTypeMap.find(item => item.value == type )
    if (!current) return '-'
    if (current) return current.title
  }

  const { getFieldDecorator } = props.form

  return (
    <ModalDom
      width="950px"
      title="详情"
      visible={visible}
      loading={false}
      footer={<Button onClick={() => setVisible(false)}>关闭</Button>}
      onCancel={() => setVisible(false)}
    >
      <div className="custom">
        <Form>
          <DetailTitle title={modalData.roomType === 1 ? '公寓信息' : '业主信息'} boxStyle={{ marginTop: 0 }} />
          <CustomRow>
            <CustomCol label="客户名称" required>
              {getFieldDecorator('name', {
                rules: [{ required: true, message: '请输入', }],
                initialValue: modalData.name || ''
              })(
                <Input />
              )}
            </CustomCol>
            <CustomCol label="客户手机" required>
              {getFieldDecorator('phone', {
                rules: [{ required: true, message: '请输入', }],
                initialValue: modalData.phone || ''
              })(
                <Input />
              )}
            </CustomCol>
            <CustomCol label="城市" required>
              {getFieldDecorator('cityName', {
                rules: [{ required: true, message: '请输入', }],
                initialValue: modalData.cityName + '-' + modalData.area + '-' + modalData.street || '-'
              })(
                <Input />
              )}
            </CustomCol>
          </CustomRow>
          {
            modalData.roomType === 1 
              ? (
                <CustomRow divider>
                  <CustomCol label="经营性质" required>
                    {getFieldDecorator('businessNature', {
                      rules: [{ required: true, message: '请输入', }],
                      initialValue: modalData.businessNature || ''
                    })(
                      <Input />
                    )}
                  </CustomCol>
                  <CustomCol label="公寓名称" required>
                    {getFieldDecorator('apartmentName', {
                      rules: [{ required: true, message: '请输入', }],
                      initialValue: modalData.apartmentName || ''
                    })(
                      <Input />
                    )}
                  </CustomCol>
                  <CustomCol label="公寓地址" required>
                    {getFieldDecorator('apartmentAddress', {
                      rules: [{ required: true, message: '请输入', }],
                      initialValue: modalData.apartmentAddress || ''
                    })(
                      <Input />
                    )}
                  </CustomCol>
                </CustomRow>
              )
              : (
                <React.Fragment>
                  <CustomRow divider>
                    <CustomCol label="房号" required>
                      {getFieldDecorator('roomNo', {
                        rules: [{ required: true, message: '请输入', }],
                        initialValue: modalData.roomNo || ''
                      })(
                        <Input />
                      )}
                    </CustomCol>
                    <CustomCol label="面积" required>
                      {getFieldDecorator('housingArea', {
                        rules: [{ required: true, message: '请输入', }],
                        initialValue: modalData.housingArea || ''
                      })(
                        <Input />
                      )}
                    </CustomCol>
                    <CustomCol label="户型" required>
                      {getFieldDecorator('layout', {
                        rules: [{ required: true, message: '请输入', }],
                        initialValue: modalData.layout || ''
                      })(
                        <Input />
                      )}
                    </CustomCol>
                  </CustomRow>
                  <CustomRow divider>
                    <CustomCol label="地址" required>
                      {getFieldDecorator('apartmentAddress', {
                        rules: [{ required: true, message: '请输入', }],
                        initialValue: modalData.apartmentAddress || ''
                      })(
                        <Input />
                      )}
                    </CustomCol>
                  </CustomRow>
                </React.Fragment>
              )
          }
          <DetailTitle title="运营数据" boxStyle={{ marginTop: 20 }} />
          {
            modalData.roomType === 1
             ? (
              <React.Fragment>
                <CustomRow>
                  <CustomCol label="装修日期" required>
                    {getFieldDecorator('decorateDate', {
                      rules: [{ required: true, message: '请输入', }],
                      initialValue: modalData.decorateDate || ''
                    })(
                      <Input />
                    )}
                  </CustomCol>
                  <CustomCol label="房源配置" required colStyle={{ width: 500 }}>
                    {getFieldDecorator('housingAllocation', {
                      rules: [{ required: true, message: '请输入', }],
                      initialValue: modalData.housingAllocation || ''
                    })(
                      <Input />
                    )}
                  </CustomCol>
                </CustomRow>
                <CustomRow divider>
                  <CustomCol label="公寓规模" required subfix="间">
                    {getFieldDecorator('apartmentScale', {
                      rules: [{ required: true, message: '请输入', }],
                      initialValue: modalData.apartmentScale || ''
                    })(
                      <Input />
                    )}
                  </CustomCol>
                  <CustomCol label="已租间数" required subfix="间">
                    {getFieldDecorator('haveRentNum', {
                      rules: [{ required: true, message: '请输入', }],
                      initialValue: modalData.haveRentNum || ''
                    })(
                      <Input />
                    )}
                  </CustomCol>
                  <CustomCol label="待租间数" required subfix="间">
                    {getFieldDecorator('notRentNum', {
                      rules: [{ required: true, message: '请输入', }],
                      initialValue: modalData.notRentNum || 0
                    })(
                      <Input />
                    )}
                  </CustomCol>
                </CustomRow>
                <CustomRow divider>
                  <CustomCol label="预计月应收" required subfix="元">
                    {getFieldDecorator('monthlyIncome', {
                      rules: [{ required: true, message: '请输入', }],
                      initialValue: modalData.monthlyIncome || ''
                    })(
                      <Input />
                    )}
                  </CustomCol>
                  <CustomCol label="应付成本" required subfix="元">
                    {getFieldDecorator('monthImputedCost', {
                      rules: [{ required: true, message: '请输入', }],
                      initialValue: modalData.monthImputedCost || ''
                    })(
                      <Input />
                    )}
                  </CustomCol>
                </CustomRow>
              </React.Fragment>
            )
            : (
              <React.Fragment>
                <CustomRow>
                  <CustomCol label="装修配置" required>
                    {getFieldDecorator('decorateConfig', {
                      rules: [{ required: true, message: '请输入', }],
                      initialValue: _fomartDecorate(modalData.decorateConfig)
                    })(
                      <Input />
                    )}
                  </CustomCol>
                  <CustomCol label="房源配置" required colStyle={{ width: 500 }}>
                    {getFieldDecorator('housingAllocation', {
                      rules: [{ required: true, message: '请输入', }],
                      initialValue: modalData.housingAllocation || ''
                    })(
                      <Input />
                    )}
                  </CustomCol>
                </CustomRow>
                <CustomRow divider>
                  <CustomCol label="剩余租期" required subfix="个月">
                    {getFieldDecorator('remainingLease', {
                      rules: [{ required: true, message: '请输入', }],
                      initialValue: modalData.remainingLease || ''
                    })(
                      <Input />
                    )}
                  </CustomCol>
                  <CustomCol label="月收入" required subfix="元">
                    {getFieldDecorator('monthlyIncome', {
                      rules: [{ required: true, message: '请输入', }],
                      initialValue: modalData.monthlyIncome || ''
                    })(
                      <Input />
                    )}
                  </CustomCol>
                </CustomRow>
              </React.Fragment>
            )
          }
          
          <DetailTitle title="额度预估" boxStyle={{ marginTop: 20 }} />
          <CustomRow>
            <CustomCol label="评分" required>
              {getFieldDecorator('score', {
                rules: [{ required: true, message: '请输入', }],
                initialValue: modalData.score || ''
              })(
                <Input />
              )}
            </CustomCol>
            <CustomCol label="评估金额" required subfix="元">
              {getFieldDecorator('assessAmount', {
                rules: [{ required: true, message: '请输入', }],
                initialValue: modalData.assessAmount || ''
              })(
                <Input />
              )}
            </CustomCol>
          </CustomRow>
          <DetailTitle title="照片" boxStyle={{ marginTop: 20 }} />
          <CustomRow>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {
                modalData.attachList && modalData.attachList.length ?
                modalData.attachList.map(item => (
                  <Img src={item.fileUrl} key={item.id} style={{ width: '100px', height: '100px', marginRight: 10, marginBottom: 10 }} />
                )) : null
              }
            </div>
          </CustomRow>
        </Form>
      </div>
    </ModalDom>
  )
}

export default Form.create()(forwardRef(Detail))


// WEBPACK FOOTER //
// ./src/page/Employee/components/CustomerDetail/index.jsx